export const assetConstants = {
    SET_PARAMS_REQUEST: 'ASSETS_SET_PARAMS_REQUEST',

    GETALL_REQUEST: 'ASSETS_GETALL_REQUEST',
    GETALL_SUCCESS: 'ASSETS_GETALL_SUCCESS',
    GETALL_FAILURE: 'ASSETS_GETALL_FAILURE',

    DELETE_REQUEST: 'ASSETS_DELETE_REQUEST',
    DELETE_SUCCESS: 'ASSETS_DELETE_SUCCESS',
    DELETE_FAILURE: 'ASSETS_DELETE_FAILURE',

    GET_REQUEST: 'ASSETS_GET_REQUEST',
    GET_SUCCESS: 'ASSETS_GET_SUCCESS',
    GET_FAILURE: 'ASSETS_GET_FAILURE',

    ADD_REQUEST: 'ASSETS_ADD_REQUEST',
    ADD_SUCCESS: 'ASSETS_ADD_SUCCESS',
    ADD_FAILURE: 'ASSETS_ADD_FAILURE',

    UPDATE_REQUEST: 'ASSETS_UPDATE_REQUEST',
    UPDATE_SUCCESS: 'ASSETS_UPDATE_SUCCESS',
    UPDATE_FAILURE: 'ASSETS_UPDATE_FAILURE',

    UPDATE_FIELD_REQUEST: 'ASSETS_UPDATE_FIELD_REQUEST',
    UPDATE_FIELD_SUCCESS: 'ASSETS_UPDATE_FIELD_SUCCESS',
    UPDATE_FIELD_FAILURE: 'ASSETS_UPDATE_FIELD_FAILURE',

    UPLOAD_FILE_REQUEST: 'ASSETS_UPLOAD_FILE_REQUEST',
    UPLOAD_FILE_SUCCESS: 'ASSETS_UPLOAD_FILE_SUCCESS',
    UPLOAD_FILE_FAILURE: 'ASSETS_UPLOAD_FILE_FAILURE',
}